import { IDrug } from './Drug.types';

export const initialDrug : IDrug = {
  group: "",
  drug:  "",
  quantity: ""
}